import { render, staticRenderFns } from "./SkeletonMobileViewsHistoryCard.vue?vue&type=template&id=5acb18a6&"
import script from "./SkeletonMobileViewsHistoryCard.vue?vue&type=script&lang=js&"
export * from "./SkeletonMobileViewsHistoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5acb18a6')) {
      api.createRecord('5acb18a6', component.options)
    } else {
      api.reload('5acb18a6', component.options)
    }
    module.hot.accept("./SkeletonMobileViewsHistoryCard.vue?vue&type=template&id=5acb18a6&", function () {
      api.rerender('5acb18a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/navigationhistory/SkeletonMobileViewsHistoryCard.vue"
export default component.exports